import { reportEvent } from '~/domains/analytics';
import type { PromoCarouselLocation } from '~/domains/promotions/types';

import type { MissionAssignment } from './types/missions.types';

/**
 * Surface a missions event is attributed to. Mirrors the backend-driven
 * `PromoCarouselLocation` values (`home | quickpicks | contest | promotions`),
 * plus `pusher` for completed-mission modals opened by a real-time push.
 */
export type MissionAnalyticsLocation = PromoCarouselLocation | 'pusher';

/** Shared mission identity props sent on both "opened" events (snake_case per analytics contract). */
const buildMissionProps = (missionAssignment: MissionAssignment) => ({
  mission_id: missionAssignment.assignmentId,
  mission_title: missionAssignment.mission.title,
  mission_type: missionAssignment.mission.type,
  reward_value: missionAssignment.mission.rewardValue,
});

export const reportMissionsTabViewed = ({
  location,
}: {
  location: PromoCarouselLocation;
}) => {
  reportEvent('Missions > Tab Viewed', { location });
};

export const reportMissionDetailOpened = ({
  missionAssignment,
  location,
}: {
  missionAssignment: MissionAssignment;
  location: PromoCarouselLocation;
}) => {
  reportEvent('Missions > Detail Opened', {
    ...buildMissionProps(missionAssignment),
    location,
  });
};

export const reportMissionCompletedOpened = ({
  missionAssignment,
  location,
}: {
  missionAssignment: MissionAssignment;
  location: MissionAnalyticsLocation;
}) => {
  reportEvent('Missions > Completed Opened', {
    ...buildMissionProps(missionAssignment),
    location,
    already_seen: missionAssignment.completionSeenAt !== null,
  });
};
